import React from "react";
import useStore from "../../../../../../context/useStore";

const useGlobalState = () => {
  const [state, dispatch] = useStore();
  return { gState: state, gDispatch: dispatch };
};

export default useGlobalState;
